import { IProjectInfo } from 'library/ts/IProjectInfo';
import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { ImportRole } from 'library/ts/model/enums/config/ImportRole';
import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { Protocol } from 'library/ts/model/enums/net/Protocol';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { SubDomain } from 'library/ts/model/enums/web/SubDomain';
import { Namespace } from 'library/ts/namespaces/Namespace';
import { ProjectInfo } from 'library/ts/ProjectInfo';

const projectInfo: IProjectInfo = ProjectInfo;
const urlPrefix = `${Protocol.HTTPS}://${SubDomain.PLAYER_SERVICES}.${Domain.CBSCOM}/`;
const cssBaseUrl = `${urlPrefix}${projectInfo?.app_output_dir?.tag_plugin_mobile_web_ui?.token}/css/`;
const cssMin = projectInfo?.app_output_file?.tag_plugin_mobile_web_ui?.css?.min;

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Mobile Web UI plugin configuration. Uses the standard plugin loader fields
 * (`params.preload`/`params.owner`/`params.import` — see `TagConfigDataService.ts` for the
 * sibling example). Ships its own CSS (`import.css`), unlike Nerd Mode / Data Service.
 *
 * `import.css.url` carries per-brand variants (`pplus`/`plutotv`/`cbs`), same shape as
 * `DefaultTagConfig.ts`'s `Imports.params.smart_tag.skin_css.url` — `PluginUtilities.
 * loadPluginScripts()` already loads the brand-specific file after the default one generically
 * for any plugin using this shape (see `ILoadPluginScriptsArgument.brand`), so no extra
 * wiring is needed here beyond populating the URLs. Each brand's file carries only the
 * customization the resolved `IMobileWebUICustomizer` implementation actually needs — today
 * that's real for Pluto TV, empty placeholders for P+/CBS.com.
 *
 * `enabled`/`import.app.enabled`/`import.css.enabled` default to `false` here — the real
 * value is computed from actual embedType/capabilities signals and set once in `TagModel.ts`'s
 * `processDefaultTagConfig()`, before this config is ever read by the plugin loader. See that
 * file for the enablement condition.
 */
export const TagConfigMobileWebUI = {
	category: ConfigModuleCategory.PLUGIN,
	enabled: false,
	params: {
		preload: true,
		owner: 'PlayerManager',
		import: {
			app: {
				enabled: false,
				type: ImportType.SCRIPT,
				role: ImportRole.EXECUTABLE,
				namespace: Namespace.TAG_PLUGIN_MOBILE_WEB_UI,
				url: {
					regular: `${urlPrefix}${projectInfo?.app_output_dir?.tag_plugin_mobile_web_ui?.token}/${projectInfo?.app_output_file?.tag_plugin_mobile_web_ui?.js?.min?.token}`
				},
				order: 1
			},
			css: {
				enabled: false,
				type: ImportType.STYLE,
				role: ImportRole.PLAYER_UI,
				namespace: undefined,
				url: {
					regular: `${cssBaseUrl}${cssMin?.token}`,
					pplus: `${cssBaseUrl}${cssMin?.pplus?.token || cssMin?.token}`,
					plutotv: `${cssBaseUrl}${cssMin?.plutotv?.token || cssMin?.token}`,
					cbs: `${cssBaseUrl}${cssMin?.cbs?.token || cssMin?.token}`
				},
				order: 2
			}
		}
	}
};